// The list selects only what a reader of the list uses: this tab's columns and the
// payments report (reports/services/DetailReportsService.ts builds on fetchRecords).
// paymentIntentId, chargeId, createdByUsername and updated stay on getPaymentEvent,
// the single-record read (§11: a field that is not fetched cannot leak).
export const listPaymentEvents = `
   query listPaymentEvents($filter: PaymentEventsFilterInput, $limit: Int, $nextToken: String, $sort: SortInput) {
       listPaymentEvents(filter: $filter, limit: $limit, nextToken: $nextToken, sort: $sort) {
           items {
                id
                invoiceId
                customerId
                status
                amount
                currency
                paymentMethodLast4
                failureCode
                failureMessage
                occurredAt
                created
           }
           nextToken
       }
   }
`;

export const getPaymentEvent = `
   query getPaymentEvent($id: ID!) {
       getPaymentEvent(id: $id) {
            id
            invoiceId
            customerId
            status
            amount
            currency
            paymentIntentId
            chargeId
            paymentMethodLast4
            failureCode
            failureMessage
            occurredAt
            createdByUsername
            created
            updated
       }
}`;
